import * as yup from "yup";

yup.addMethod(yup.string, "minText", function minText(min, message) {
  return this.test("minText", message, (value) => {
    if (!value) {
      return true;
    } // let required() handle empty values
    const text = value.replace(/<[^>]*>/g, "").trim();
    return text.length >= min;
  });
});

export function createYupSchema(schema, config) {
  const { name, validationType, validations = [] } = config;

  if (!yup[validationType]) {
    return schema;
  }

  let validator = yup[validationType]();

  validations.forEach((validation) => {
    const { params, type } = validation;
    if (!validator[type]) {
      return;
    }
    validator = validator[type](...params);
  });

  schema[name] = validator;

  return schema;
}
